import { render, staticRenderFns } from "./ModalEntityObject.vue?vue&type=template&id=58250410&scoped=true"
import script from "./ModalEntityObject.vue?vue&type=script&lang=js"
export * from "./ModalEntityObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58250410",
  null
  
)

export default component.exports